import * as _ from "lodash";
import http from "../constant/api-widget";

export const messageWidgetService = {
  queryMessageWidgetBySessionId: async (sessionId, filter, domain) => {
    const result = await http.get(
      `/api/message-widget/session-id/${sessionId}/query`,
      {
        params: filter,
        domain,
      }
    );

    return result;
  },
  sendMessageWidget: async (data, isFormData = false, domain) => {
    const result = await http.post(`/api/message-widget/send`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
      domain,
    });

    return result;
  },
};
